import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { shinglesRoutes } from 'modules/forms/constants/routes.constants';
import Assessment from './Assessment';
import Confirmation from './Confirmation';
import Disqualification from '../Disqualification';
import GenerealQualifier from './GenerealQualifier';
import PhotoUpload from './PhotoUpload';
import Prescreening from './Prescreening';
import SecondaryScreening from './SecondaryScreening';
import FormAcceptTerms from '../FormAcceptTerms';

const FormRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route path={shinglesRoutes.prescreening} exact component={Prescreening} />
      <Route path={shinglesRoutes.generalQualifier} exact component={GenerealQualifier} />
      <Route path={shinglesRoutes.secondaryScreening} exact component={SecondaryScreening} />
      <Route path={shinglesRoutes.assessment} exact component={Assessment} />
      <Route path={shinglesRoutes.photoUpload} exact component={PhotoUpload} />
      <Route path={shinglesRoutes.acceptTerms} exact component={FormAcceptTerms} />
      <Route path={shinglesRoutes.disqualification} exact component={Disqualification} />
      <Route path={shinglesRoutes.confirmation} exact component={Confirmation} />
      <Redirect to={shinglesRoutes.prescreening} />
    </Switch>
  );
};

export default FormRoutes;
